export { default } from './Memoria';
